// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';

// 引入需要的组件
import Home from './pages/index.vue';
import Admin from './pages/admin/admin.vue';

Vue.use(VueRouter);

// 配置路由
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin
    }
];

// 创建 router 实例
const router = new VueRouter({
    // mode: 'history', // 使用 history 模式，可以去掉 URL 中的 # 符号
    routes
});

export default router;
